export default "__VITE_ASSET__vSeVstD5__"